<section class="toast-test w-full max-w-3xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col gap-1">
    <p class="text-base text-ink-500">DEV</p>
    <h1 class="text-3xl font-bold text-primary-700">בדיקת הודעות (Toasts)</h1>
    <p class="text-base text-ink-500">
      לחיצה על כפתור תפתח הודעת טוסט מהסוג המתאים. במצב הנוכחי (DEBUG) הטוסטים נשארים פתוחים עד סגירה ידנית עם ה־✕.
    </p>
  </header>

  <div class="card-2026 space-y-3">
    <h2 class="text-lg font-semibold text-ink-800">כפתור אחד לכל סוג</h2>

    <div class="grid grid-cols-1 gap-2">
      <button
        *ngFor="let tc of cases"
        type="button"
        class="flex items-center justify-between gap-3 rounded-lg border border-ink-100 bg-white hover:bg-primary-50 focus:bg-primary-100 focus:outline-none transition-colors px-3 py-3 min-h-tap text-right"
        (click)="fire(tc)"
      >
        <span class="flex items-center gap-3 min-w-0">
          <span
            class="inline-flex items-center justify-center w-8 h-8 rounded-full flex-shrink-0"
            [class.bg-success-soft]="tc.kind === 'success'"
            [class.text-success]="tc.kind === 'success'"
            [class.bg-danger-soft]="tc.kind === 'error'"
            [class.text-danger]="tc.kind === 'error'"
            [class.bg-warning-soft]="tc.kind === 'warning'"
            [class.text-warning]="tc.kind === 'warning'"
            [class.bg-primary-100]="tc.kind === 'info'"
            [class.text-primary-700]="tc.kind === 'info'"
          >
            <i class="material-symbols-outlined text-lg" aria-hidden="true">
              <ng-container [ngSwitch]="tc.kind">
                <ng-container *ngSwitchCase="'success'">check_circle</ng-container>
                <ng-container *ngSwitchCase="'error'">error</ng-container>
                <ng-container *ngSwitchCase="'warning'">warning</ng-container>
                <ng-container *ngSwitchDefault>info</ng-container>
              </ng-container>
            </i>
          </span>
          <span class="flex flex-col min-w-0">
            <span class="text-base font-semibold text-ink-800 truncate">{{ tc.title }}</span>
            <span *ngIf="tc.description" class="text-sm text-ink-500 truncate">{{ tc.description }}</span>
            <span *ngIf="!tc.description" class="text-sm text-ink-400 italic">ללא תיאור</span>
          </span>
        </span>
        <span
          class="text-xs font-medium uppercase px-2 py-0.5 rounded-full flex-shrink-0"
          [class.bg-success-soft]="tc.kind === 'success'"
          [class.text-success]="tc.kind === 'success'"
          [class.bg-danger-soft]="tc.kind === 'error'"
          [class.text-danger]="tc.kind === 'error'"
          [class.bg-warning-soft]="tc.kind === 'warning'"
          [class.text-warning]="tc.kind === 'warning'"
          [class.bg-primary-100]="tc.kind === 'info'"
          [class.text-primary-700]="tc.kind === 'info'"
        >
          {{ tc.kind }}
        </span>
      </button>
    </div>
  </div>

  <div class="card-2026 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
    <div>
      <h2 class="text-lg font-semibold text-ink-800">כפתור נפרד</h2>
      <p class="text-sm text-ink-500 mt-1">פותח בבת אחת את כל הטוסטים ברשימה למעלה כדי לבדוק ערימה והתנהגות.</p>
    </div>
    <button
      type="button"
      class="btn-2026--accent w-full md:w-auto md:min-w-[220px]"
      (click)="fireAll()"
    >
      <span class="material-symbols-outlined" aria-hidden="true">layers</span>
      פתח את כל הטוסטים
    </button>
  </div>

</section>
